import { computed, defineComponent } from '@vue/composition-api';
// Order is meaningful: the states a reader is most likely to be looking at
// come first. "booked" is last in both because it is the only one that is a
// mark on a cell rather than the cell itself.
//
// `booked` is new. It is the `we-dot` in MonthView.vue:57-67, drawn whenever
// dayLimits[day].hasActiveBookings -- a day that already carries bookings. It
// has been on the calendar the whole time with nothing anywhere saying what it
// meant, which is the worst kind of legend gap: a mark you can see and cannot
// look up.
const LIST = {
    month: [
        'opened',
        'partially',
        'month-closed',
        'selected',
        'today',
        'past',
        'booked'
    ],
    week: ['opened', 'week-closed', 'selected', 'past', 'booked']
};
export default defineComponent({
    props: {
        mode: {
            type: String,
            default: 'month'
        }
    },
    setup(props) {
        return {
            items: computed(() => LIST[props.mode])
        };
    }
});
